"use client";
import { createContext, useContext } from "react";

type SLOContextValues = { uid: string; sloChannel: string };
export const SloContext = createContext<SLOContextValues>({} as SLOContextValues);

export const useSloContext = () => useContext(SloContext);
